<template>
  <div class="layouts-empty">
    <slot class-name="layouts-empty__view" />
  </div>
</template>

<style scoped lang="scss">
.layouts-empty {
  $parent: &;

  display: flex;
  flex-direction: column;

  &:deep(#{$parent}__view) {
    flex-grow: 1;
  }
}
</style>
